import React, { useState, useEffect } from 'react';
import { FiMaximize2, FiX, FiMonitor, FiImage, FiExternalLink } from 'react-icons/fi';
import { normalizeUploadedImageUrl } from '../../../apis/uploadImage';

const ProductImageMockup = ({
    src,
    alt = '',
    title = '',
    caption = '',
    badge = '',
    className = '',
}) => {
    const [isLightboxOpen, setIsLightboxOpen] = useState(false);
    const normalizedSrc = normalizeUploadedImageUrl(src);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') setIsLightboxOpen(false);
        };
        if (isLightboxOpen) {
            document.body.style.overflow = 'hidden';
            window.addEventListener('keydown', handleKeyDown);
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [isLightboxOpen]);

    if (!normalizedSrc) return null;

    const displayTitle = title || caption || 'Giao diện hệ thống';

    return (
        <>
            <div className={`ps-dribbble-mockup ${className}`}>
                {/* Ambient glow effect behind mockup */}
                <div className="ps-mockup-glow" />

                <div className="ps-mockup-window" onClick={() => setIsLightboxOpen(true)}>
                    {/* Window Top Bar (Mac OS / SaaS Window Style) */}
                    <div className="ps-mockup-window__header">
                        <div className="ps-mockup-window__dots">
                            <span className="dot dot--red" />
                            <span className="dot dot--yellow" />
                            <span className="dot dot--green" />
                        </div>

                        <div className="ps-mockup-window__title-pill">
                            <FiMonitor className="pill-icon" />
                            <span className="pill-text">{displayTitle}</span>
                        </div>

                        <div className="ps-mockup-window__actions">
                            <button
                                type="button"
                                className="ps-mockup-zoom-btn"
                                title="Nhấn để phóng to ảnh"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setIsLightboxOpen(true);
                                }}
                            >
                                <FiMaximize2 size={13} />
                                <span>Phóng to</span>
                            </button>
                        </div>
                    </div>

                    {/* Image Viewport */}
                    <div className="ps-mockup-window__viewport">
                        <img
                            src={normalizedSrc}
                            alt={alt || caption || title || 'Giao diện hệ thống'}
                            className="ps-mockup-window__img"
                            loading="lazy"
                        />
                        <div className="ps-mockup-window__overlay">
                            <div className="ps-mockup-overlay-badge">
                                <FiMaximize2 size={16} />
                                <span>Xem toàn màn hình</span>
                            </div>
                        </div>
                    </div>

                    {/* Bottom Caption Bar */}
                    {(caption || badge) && (
                        <div className="ps-mockup-window__footer">
                            <div className="ps-mockup-footer__caption">
                                <FiImage className="footer-icon" />
                                <span>{caption || title}</span>
                            </div>
                            {badge && <span className="ps-mockup-footer__badge">{badge}</span>}
                        </div>
                    )}
                </div>
            </div>

            {/* Lightbox Zoom Modal */}
            {isLightboxOpen && (
                <div className="ps-lightbox-overlay" onClick={() => setIsLightboxOpen(false)}>
                    <div className="ps-lightbox-content" onClick={(e) => e.stopPropagation()}>
                        <div className="ps-lightbox-header">
                            <div className="ps-lightbox-title">
                                <FiMonitor size={18} />
                                <strong>{displayTitle}</strong>
                            </div>

                            <div className="ps-lightbox-header-actions">
                                <a
                                    href={normalizedSrc}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="ps-lightbox-open-link"
                                    title="Mở ảnh gốc trong tab mới"
                                >
                                    <span>Mở tab mới</span>
                                    <FiExternalLink size={14} />
                                </a>

                                <button
                                    type="button"
                                    className="ps-lightbox-header-close"
                                    onClick={() => setIsLightboxOpen(false)}
                                    title="Đóng (Esc)"
                                >
                                    <FiX size={20} />
                                </button>
                            </div>
                        </div>

                        <div className="ps-lightbox-img-wrapper" onClick={() => setIsLightboxOpen(false)}>
                            <img
                                src={normalizedSrc}
                                alt={alt || caption || title || 'Giao diện phóng to'}
                                className="ps-lightbox-img"
                                onClick={(e) => e.stopPropagation()}
                            />
                        </div>

                        {caption && (
                            <div className="ps-lightbox-caption">
                                <p>{caption}</p>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default ProductImageMockup;
